import { useEffect, useState } from "react";
import { apiHandler } from "../../api";
import { endpoint } from "../../api/endpoint";
import { useDispatch, useSelector } from "react-redux";

const useDashboard = () => {
  const { authData, storeId } = useSelector((state) => state.loginSlice);
  const [stores, setStores] = useState([]);
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();

  const fetchStores = async () => {
    try {
      setLoader(true);
      const response = await apiHandler({
        url: endpoint.FETCH_STORE_DATA,
        authToken: authData,
        method: "GET",
        storeId,
        dispatch,
      });
      if (response.data.status === "success") {
        setStores(response.data.data.storeData);
      }
    } catch (error) {
      console.log("Error fetching stores", error);
    } finally {
      setLoader(false);
    }
  };

  const handleToggle = async (storeId, currentStatus) => {
    try {
      const newStatus = !currentStatus;

      await updateStore(storeId, newStatus);

      const updatedStore = stores.map((d) => {
        if (d.iStoreId === storeId) {
          return { ...d, bIsActive: newStatus };
        }
        return { ...d, bIsActive: false };
      });
      //   console.log(updatedStore);

      setStores(updatedStore);
    } catch (error) {
      console.error("Error toggling distributor status:", error);
    }
  };

  const updateStore = async (storeId) => {
    try {
      const result = await apiHandler({
        url: `${endpoint.UPDATE_STORE_STATUS}/${storeId}`,
        method: "PATCH",
        authToken: authData,
        storeId,
      });

      if (result.data.status === "success") {
        fetchStores();
      }
    } catch (error) {
      console.error("Error updating distributor:", error);
    }
  };

  useEffect(() => {
    fetchStores();
  }, []);

  return { stores, handleToggle, loader };
};

export default useDashboard;
